<template>
  <span
    class="avocash"
    ><span class="avocash_primary">avo</span><span class="avocash_gold avocash">¢</span
    ><span class="avocash_primary">ash</span></span
  >
</template>
<style>

</style>
<script setup>
import { f7, theme } from "framework7-vue";
</script>
